import { render, staticRenderFns } from "./AddEditCampaignDialog.vue?vue&type=template&id=2bafc0dd"
import script from "./AddEditCampaignDialog.vue?vue&type=script&lang=js"
export * from "./AddEditCampaignDialog.vue?vue&type=script&lang=js"
import style0 from "./AddEditCampaignDialog.vue?vue&type=style&index=0&id=2bafc0dd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports